import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { fetchLocalization } from "features/localization/fetchLocalization"; // Ваш запрос к AWS

const awsBackend = {
  type: "backend",
  init: () => {},
  read: async (
    language: string,
    namespace: string,
    callback: (err: any, data: any) => void,
  ) => {
    try {
      const response = await fetchLocalization(language); // Используем ваш существующий запрос
      callback(null, response); // Предполагается, что response — это объект { key: "translation" }
    } catch (error) {
      callback(error, null);
    }
  },
};

i18next
  // @ts-expect-error
  .use(awsBackend)
  .use(initReactI18next)
  .init({
    lng: "en", // Дефолтный язык
    fallbackLng: "en", // Если перевод не найден
    ns: ["common"], // Пространство имён
    defaultNS: "common",
    // debug: process.env.NODE_ENV === "development", // Отладка только в dev
    interpolation: {
      escapeValue: false, // React уже экранирует
    },
  });

export default i18next;
